import "./taskbar.css";
import Promotions from "../../Pages/Speaker/Promotions/Promotions";
import Message from "../../Pages/Message/Message";
import Headphones from "../../Pages/Headphones/Headphones";
import Location from "../../Pages/Location/Location";
import Mail from "../../Pages/Mail/Mail";
import Picture from "../../Pages/Picture/Picture";
import CustomCalendar from "../../Pages/CustomCalendar/CustomCalendar";
import Calendar from "../../Pages/CustomCalendar/Calendar";
import Biography from "../../Pages/Folder/BiographyAndPresentationDocument/Biography";
import General from "../../Pages/Folder/GeneralDocument/General";
import Notebook from "../../Pages/Notebook/Notebook";
import Key from "../../Pages/Key/Key";
import Envelope from "../../Pages/Envelope/Envelope";
import LanguageLocation from "../../Pages/Language/LenguageLocation/LanguageLocation";
import Translate from "../../Pages/Language/TranslateAdminPanel/Translate";
import Cooperation from "../../Pages/Speaker/Cooperation/Cooperation";
import Hr from "../../Pages/Speaker/HR/Hr";
import LocationDocument from "../../Pages/Folder/LocationDocument/Location";
import SideBar from "../sideBar/SideBar";
import CustomDatePicker from "../../Pages/CustomCalendar/CustomCalendar";
import AddLocation from "../addLocation/AddLocation";
import ScrollText from "../ScrollText/ScrollText";
import { useEffect, useRef, useState } from "react";
import { useGlobalContext } from "../../../Context/Context";
import Lorem from "../../lorem.pdf";
import Button from "../../Custom/Button/Button";
import MidleTaskbar from "./MidleTaskbar";
import SingleMessage from "../../Pages/Message/SingleMessage";
import Editor from "../../../Editor/Editor/Editor";
import FolderLocation from "../Folder/FolderLocation";
import Notification from "../Notification/Notification";
import cancelIcon from "../../picture/cancel.png";
import settingsIcon from "../../picture/16.png";
import Settings from "../settings/Settings";
import extendMidleIcon from "../../picture/extend-midle.png";
import SettingsEditor from "../../../SettingsEditor/SettingsEditor";
import Gallery from "../../../Gallery/Gallery";
import LocationUsers from "../../Pages/LocationUsers/LocationUsers";
import LocationStats from "../../Pages/LocationStats/LocationStats";
import ReportTemplate from "../../Pages/ReportTemplate/ReportTemplate";
import Docs from "../../Pages/Docs/Docs";
import Contacts from "../../Pages/Contacts/Contacts";
import LocationFrame from "../../Pages/Contacts/LocationFrame";
import DocumentViewer from "../../Pages/Docs/DocumentViewer";
import Zaposleni from "../Zaposleni/Zaposleni";
import TabelaVerzijeObrazac from "../Documents/evidencije/TabelaVerzijeObrazac";
import ProcenaRizika from "../Documents/ProcenaRizika";
import ZastitaOdPozara from "../Documents/ZastitaOdPozara";
import ZastitaZivotneSredine from "../Documents/ZastitaZivotneSredine";
import DokumentaZaposlenih from "../Documents/dokumenta-zaposlenih/DokumentaZaposlenih";
import OrganizacionaSema from "../Documents/procena-rizika/organizaciona-sema/OrganizacionaSema";
import PravilnikORadu from "../Documents/procena-rizika/pravilnik-o-radu/PravilnikORadu";
import plusIcon from "../../picture/plus.png";
import GlobalnoDodavanjeDokumenta from "../Documents/globalno-dodavanje/GlobalnoDodavanjeDokumenta";
import EvidencijeObrazac1 from "../Documents/evidencije/EvidencijeObrazac1";
import EvidencijeObrazac2 from "../Documents/evidencije/EvidencijeObrazac2";
import EvidencijeObrazac3 from "../Documents/evidencije/EvidencijeObrazac3";
import Evidencije5 from "../Documents/evidencije/evidencije5/Evidencije5";

import EvidencijeObrazac8 from "../Documents/evidencije/EvidencijeObrazac8";
import EvidencijeObrazac9 from "../Documents/evidencije/EvidencijeObrazac9";
import EvidencijeObrazac10 from "../Documents/evidencije/EvidencijeObrazac10";
import EvidencijeObrazac4 from "../Documents/evidencije/EvidencijeObrazac4";
import Evidencije7 from "../Documents/evidencije/evidencije7/Pocetna";
import FolderDocumentMiddle from "../FolderDocument/FolderDocumentMiddle";
import FolderDocumentSidebar from "../FolderDocument/FolderDocumentSidebar";
import Evidencije6 from "../Documents/evidencije/evidencije6/Evidencije6";
import Akt from "../Documents/procena-rizika/akt/Akt";
import SistematizacijaRadnihMesta from "../Documents/procena-rizika/sistematizacija-radnih-mesta/Pocetna";
import PrvaPomoc from "../Documents/procena-rizika/prva-pomoc/PrvaPomoc";
import EvidencijeObrazac11 from "../Documents/evidencije/EvidencijeObrazac11";
import MasineUredjaji from "../Documents/sredstva-oprema/masine-uredjaji/MasineUredjaji";
import SredstvaPrvaPomoc from "../Documents/sredstva-oprema/sredstva-prva-pomoc/Pocetna";
import MedicinaRada from "../Documents/procena-rizika/medicina-rada/Pocetna";
import PrevoznaSredstva from "../Documents/sredstva-oprema/prevozna-sredstva/Pocetna";
import SredstvaOpremaNotifikacije from "../Documents/sredstva-oprema/SredstvaOpremaNotifikacije";
import ElektroOprema from "../Documents/sredstva-oprema/elektro-oprema/ElektroOprema";
import KolektivnaOprema from "../Documents/sredstva-oprema/kolektivna-oprema/KolektivnaOprema";
import OstalaOprema from "../Documents/sredstva-oprema/ostala-sredstva/OstalaOprema";
import PoslovnaJedinica from "../Documents/poslovne-jedinice/PoslovnaJedinica";
import LicnaZastitnaOprema from "../Documents/sredstva-oprema/licna-zastitna-oprema/LicnaZastitnaOprema";
import OdlukeLicence from "../Documents/procena-rizika/odluke-licence/OdlukeLicence";

function Taskbar({
  currentTab,
  setCurrentTab,
  slideButton,
  setSlideButton,
  setSpeakerButton,
  setLanguageButton,
  speakerButton,
  languageButton,
  setSelectedItem,
  selectedItem,
  setCompanies,
  account,
  setSelectAccount,
}) {
  const [checkBack, setCheckBack] = useState(false); // prepraviti da bude u context-u
  const { selectedDocumentUrl, setSelectedDocumentUrl } = useGlobalContext();
  const {
    activeIconsMiddleAdmin,
    currentChatAdmin,
    setCurrentChatAdmin,
    chooseObject,
    selectedSettings,
    setActiveIconsMiddleAdmin,
    loggedUser,
    selectedNavbarDocument,
    isSelectedZaposleni,
    selectedEvidencija,
    selectedProcenaRizika,
    dictionary,
    isGlobalnoDodavanjeDokumenta,
    setIsGlobalnoDodavanjeDokumenta,
    isLZOClicked,
    setIsLZOClicked,
    selectedSredstvaOprema,
    selectedCompany,
  } = useGlobalContext();

  console.log("Ovo je chooseObject", chooseObject);

  const fileInputRef = useRef();
  const [fileNewDocument, setFileNewDocument] = useState(null);

  const [selectedLocation, setSelectedLocation] = useState(null); // Track the selected location

  const [showSettings, setShowSettings] = useState();
  const [isExtend, setIsExtend] = useState(false);
  const sideBarRef = useRef();

  const [selectedDocument, setSelectedDocument] = useState(null);

  const settings = [
    { name: "INICIJALNA PODESAVANJA" },
    { name: "STIL PANELA" },
    { name: "UPOTREBA SKLADISTA" },
    { name: "DEFINISANJE MODERATORA" },
    { name: "KORISCENJE APLIKACIJE" },
    { name: "WEB PREZENTACIJA" },
  ];

  const handleCancel = () => {
    // azuriranje niza aktivnih ikona u glavnom delu taskbara -> napravi posebnu fju u context-u za ovo
    const newActiveIconsMiddle = activeIconsMiddleAdmin.filter(
      (icon) => icon.name !== currentTab,
    );
    setActiveIconsMiddleAdmin(newActiveIconsMiddle);
    setSelectedLocation(null); // Clear selected location (if any)
    setSelectedDocument(null);
  };

  const handleExtendMidle = () => {
    setIsExtend(!isExtend);
  };

  const resetFile = () => {
    setFileNewDocument(null);
    fileInputRef.current.value = ""; // resetuje i input
  };

  const openFilePicker = () => {
    fileInputRef.current.value = "";
    fileInputRef.current.click();
  };

  const renderContent = () => {
    if (currentTab === "PROMO") return <Promotions />;
    if (currentTab === "COOPERATION") return <Cooperation />;
    if (currentTab === "MESSAGES")
      return (
        <Message
          checkBack={checkBack}
          setCheckBack={setCheckBack}
          currentTab={currentTab}
          selectedCompany={selectedCompany}
        />
      );
    if (currentTab === "HR") return <Hr />;
    // if (currentTab === "HEADPHONES")
    //   return (
    //     <Headphones
    //       checkBack={checkBack}
    //       setCheckBack={setCheckBack}
    //       selectedCompany={selectedCompany}
    //       currentTab={currentTab}
    //     />
    //   );
    if (currentTab === "HEADPHONES")
      return <Docs setSelectedDocument={setSelectedDocument} />;

    if (currentTab === "MAIL")
      return (
        <Contacts
          checkBack={checkBack}
          setCheckBack={setCheckBack}
          selectedCompany={selectedCompany}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          onLocationClick={(location) => {
            console.log("Location clicked:", location); // Debug log
            setSelectedLocation(location);
          }}
        />
      );
    if (currentTab === "LOCATION")
      return (
        <Location
          checkBack={checkBack}
          setCheckBack={setCheckBack}
          selectedCompany={selectedCompany}
          currentTab={currentTab}
        />
      );
    if (currentTab === "PICTURE")
      return (
        /*<Picture
          checkBack={checkBack}
          currentTab={currentTab}
          setCheckBack={setCheckBack}
          selectedCompany={selectedCompany}
          selectedAccount={selectedAccount}
        />*/
        <Gallery></Gallery>
      );
    if (currentTab === "FOLDER")
      return <FolderDocumentSidebar selectedCompany={selectedCompany} />;
    if (currentTab === "BIOGRAPHY") return <Biography />;
    if (currentTab === "LOCATION FOLDER") return <LocationDocument />;
    if (currentTab === "BASIC") {
      console.log(sideBarRef);
      return (
        <div className="folder-location-wrapper">
          <FolderLocation
            selectedCompany={selectedCompany}
            location={{
              location_id: null,
              location_name: loggedUser.id,
            }}
            location_input={
              chooseObject !== undefined && chooseObject !== null
                ? chooseObject.id
                : null
            }
            sideBarRef={sideBarRef}
            isLandScapeProp={false}
          />
        </div>
      );
    }
    /* if (currentTab === "NOTEBOOK") return <Notebook />*/
    if (currentTab === "KEY")
      return (
        <Key
          checkBack={checkBack}
          setCheckBack={setCheckBack}
          currentTab={currentTab}
          selectedCompany={selectedCompany}
          companyId={selectedCompany.id}
        />
      );
    if (currentTab === "LOCATION LANGUAGE") return <LanguageLocation />;
    if (currentTab === "TRANSLATE") return <Translate />;
    // if (currentTab === "CALENDAR") return <div className="taskbar-blank"></div>;
    if (currentTab === "CALENDAR") return <Calendar />;
    if (currentTab === "NOTIFICATION")
      return <Notification selectedCompany={selectedCompany} />;
    else {
      return null;
    }
  };

  console.log(chooseObject);
  console.log(selectedSettings);
  const renderMiddleContent = () => {
    let currentActive = activeIconsMiddleAdmin.find(
      (icon) => icon.name === currentTab,
    );
    console.log("Uslov ispunjen", chooseObject, account, selectedItem);
    if (selectedLocation) {
      return (
        <MidleTaskbar currentTab="LOCATION" isExtend={isExtend}>
          <LocationFrame selectedLocation={selectedLocation} />
        </MidleTaskbar>
      );
    }

    if (isSelectedZaposleni) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <Zaposleni />
        </MidleTaskbar>
      );
    }
    if (isGlobalnoDodavanjeDokumenta) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <GlobalnoDodavanjeDokumenta
            fileNewDocument={fileNewDocument}
            setCurrentTab={setCurrentTab}
            resetFile={resetFile} // <-- DODATO
            openFilePicker={openFilePicker} // <-- DODATO
              onClose={() => setIsGlobalnoDodavanjeDokumenta(false)}  // DODATO

          />
        </MidleTaskbar>
      );
    }
    if (
      selectedNavbarDocument === "PROCENA_RIZIKA" &&
      selectedProcenaRizika === 1
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <Akt companyId={selectedCompany.company_id} />
        </MidleTaskbar>
      );
    }
    if (
      selectedNavbarDocument === "PROCENA_RIZIKA" &&
      selectedProcenaRizika === 2
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <OdlukeLicence companyId={selectedCompany.company_id} />
        </MidleTaskbar>
      );
    }
    if (
      selectedNavbarDocument === "PROCENA_RIZIKA" &&
      selectedProcenaRizika === 3
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <PrvaPomoc companyId={selectedCompany.company_id} />
        </MidleTaskbar>
      );
    }
    if (
      selectedNavbarDocument === "PROCENA_RIZIKA" &&
      selectedProcenaRizika === 4
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <MedicinaRada companyId={selectedCompany.company_id} />
        </MidleTaskbar>
      );
    }
    if (
      selectedNavbarDocument === "PROCENA_RIZIKA" &&
      selectedProcenaRizika === 6
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <SistematizacijaRadnihMesta companyId={selectedCompany.company_id} />
        </MidleTaskbar>
      );
    }
    if (
      selectedNavbarDocument === "PROCENA_RIZIKA" &&
      selectedProcenaRizika === 7
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <OrganizacionaSema companyId={selectedCompany.company_id} />
        </MidleTaskbar>
      );
    }
    if (
      selectedNavbarDocument === "PROCENA_RIZIKA" &&
      selectedProcenaRizika === 8
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <PravilnikORadu />
        </MidleTaskbar>
      );
    }
    if (selectedNavbarDocument === "POSLOVNE_JEDINICE") {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <PoslovnaJedinica />
        </MidleTaskbar>
      );
    }
    if (
      selectedNavbarDocument === "SREDSTVA_OPREMA" &&
      selectedSredstvaOprema === 0
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <SredstvaOpremaNotifikacije />
        </MidleTaskbar>
      );
    }
    if (
      selectedNavbarDocument === "SREDSTVA_OPREMA" &&
      selectedSredstvaOprema === 1
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <LicnaZastitnaOprema />
        </MidleTaskbar>
      );
    }
    if (
      selectedNavbarDocument === "SREDSTVA_OPREMA" &&
      selectedSredstvaOprema === 2
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <MasineUredjaji />
        </MidleTaskbar>
      );
    }

    if (
      selectedNavbarDocument === "SREDSTVA_OPREMA" &&
      selectedSredstvaOprema === 3
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <PrevoznaSredstva />
        </MidleTaskbar>
      );
    }

    if (
      selectedNavbarDocument === "SREDSTVA_OPREMA" &&
      selectedSredstvaOprema === 4
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <ElektroOprema />
        </MidleTaskbar>
      );
    }

    if (
      selectedNavbarDocument === "SREDSTVA_OPREMA" &&
      selectedSredstvaOprema === 5
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <KolektivnaOprema />
        </MidleTaskbar>
      );
    }

    if (
      selectedNavbarDocument === "SREDSTVA_OPREMA" &&
      selectedSredstvaOprema === 6
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <SredstvaPrvaPomoc />
        </MidleTaskbar>
      );
    }

    if (
      selectedNavbarDocument === "SREDSTVA_OPREMA" &&
      selectedSredstvaOprema === 7
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <OstalaOprema />
        </MidleTaskbar>
      );
    }

    if (selectedNavbarDocument === "DOKUMENTA_ZAPOSLENIH") {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <DokumentaZaposlenih />
        </MidleTaskbar>
      );
    }
    if (selectedNavbarDocument === "ZASTITA_OD_POZARA") {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <ZastitaOdPozara />
        </MidleTaskbar>
      );
    }
    if (selectedNavbarDocument === "ZASTITA_ZIVOTNE_SREDINE") {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <ZastitaZivotneSredine />
        </MidleTaskbar>
      );
    }
    if (selectedNavbarDocument === "POSLOVNI_SARADNICI") {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <ProcenaRizika />
        </MidleTaskbar>
      );
    }
    if (selectedNavbarDocument === "UGOVORI_ODLUKE") {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <ProcenaRizika />
        </MidleTaskbar>
      );
    }

    if (
      selectedNavbarDocument === "EVIDENCIJE_OBRASCI" &&
      selectedEvidencija !== 0
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          {selectedEvidencija === 1 && <EvidencijeObrazac1 />}
          {selectedEvidencija === 2 && <EvidencijeObrazac2 />}
          {selectedEvidencija === 3 && <EvidencijeObrazac3 />}
          {selectedEvidencija === 4 && <EvidencijeObrazac4 />}
          {selectedEvidencija === 5 && <Evidencije5 />}
          {selectedEvidencija === 6 && <Evidencije6 />}
          {selectedEvidencija === 7 && <Evidencije7 />}
          {selectedEvidencija === 8 && <EvidencijeObrazac8 />}
          {selectedEvidencija === 9 && <EvidencijeObrazac9 />}
          {selectedEvidencija === 10 && <EvidencijeObrazac10 />}
          {selectedEvidencija === 11 && <EvidencijeObrazac11 />}
          {/* <TabelaVerzijeObrazac selectedEvidencija={selectedEvidencija} /> */}
        </MidleTaskbar>
      );
    }

    if (
      chooseObject !== null &&
      chooseObject.index === 3 &&
      selectedSettings === 0
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <Editor
            setSelectAccount={setSelectAccount}
            account={account}
            location={{
              location_id: chooseObject.id,
              location_name: chooseObject.data,
            }}
          />
        </MidleTaskbar>
      );
    }
    if (
      chooseObject !== null &&
      chooseObject.index === 3 &&
      selectedSettings === 2
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <LocationUsers />
        </MidleTaskbar>
      );
    }
    if (
      chooseObject !== null &&
      chooseObject.index === 3 &&
      selectedSettings === 1
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
           <SettingsEditor
            selectedCompany={selectedCompany}
            location={{
              location_id: null,
              location_name: loggedUser.id,
            }}
            location_input={
              chooseObject !== undefined && chooseObject !== null
                ? chooseObject.id
                : null
            }
            sideBarRef={sideBarRef}
            isLandScapeProp={false}
          />
        </MidleTaskbar>
      );
    }

    if (chooseObject !== null && selectedSettings === 4) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <FolderLocation
            setSelectAccount={setSelectAccount}
            account={account}
            location={{
              location_id: chooseObject.id,
              location_name: chooseObject.data,
            }}
            selectedCompany={selectedCompany}
            sideBarRef={{ current: null }}
            isLandScapeProp={true}
          />
        </MidleTaskbar>
      );
    }

    if (
      chooseObject !== null &&
      chooseObject.index === 3 &&
      selectedSettings === 5
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <LocationStats
            location={{
              location_id: chooseObject.id,
              location_name: chooseObject.data,
            }}
          />
        </MidleTaskbar>
      );
    }

    if (
      chooseObject !== null &&
      chooseObject.index === 3 &&
      selectedSettings === 3
    ) {
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <ReportTemplate />
        </MidleTaskbar>
      );
    }

    if (currentTab === "BASIC" && currentActive !== undefined)
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <FolderLocation
            setSelectAccount={setSelectAccount}
            account={account}
            location={{
              location_id: null,
              location_name: loggedUser.id,
            }}
            location_input={
              chooseObject !== undefined && chooseObject !== null
                ? chooseObject.id
                : null
            }
            selectedCompany={selectedCompany}
            sideBarRef={{ current: null }}
            isLandScapeProp={true}
          />
        </MidleTaskbar>
      );
    //  if (currentTab === "HEADPHONES" && currentActive !== undefined) {
    //   return (
    //     <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
    //       {selectedDocumentUrl ? (
    //         <iframe
    //           src={selectedDocumentUrl}
    //           title="Document Viewer"
    //           frameBorder="0"
    //           className="document-iframe"
    //         ></iframe>
    //       ) : (
    //         <Docs />
    //       )}
    //     </MidleTaskbar>
    //   );
    // }
    if (currentTab === "PICTURE" && currentActive !== undefined) {
      console.log(currentTab);
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <img
            src={currentActive.data}
            alt=""
            className="document-view-picture"
          ></img>
        </MidleTaskbar>
      );
    }
    if (currentTab === "CALENDAR" && currentActive !== undefined) {
      console.log(currentTab);
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <Calendar />
        </MidleTaskbar>
      );
    }

    if (currentTab === "MAIL" && currentActive !== undefined)
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <LocationFrame selectedCompany={selectedCompany} />
        </MidleTaskbar>
      );
    if (selectedDocument) {
      return (
        <MidleTaskbar currentTab="DOCUMENT_VIEWER" isExtend={isExtend}>
          <DocumentViewer
            documents={selectedDocument}
            onClose={() => setSelectedDocument(null)}
          />
        </MidleTaskbar>
      );
    }

    if (currentTab === "MESSAGES" && currentActive !== undefined)
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <SingleMessage
            currentChat={currentChatAdmin}
            setCurrentChat={setCurrentChatAdmin}
            currentTab={currentTab}
            isFullVisible={false}
            selectedCompany={selectedCompany}
          />
        </MidleTaskbar>
      );

    if (currentTab === "NOTEBOOK")
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <Notebook />
        </MidleTaskbar>
      );
    if (currentTab === "NOTIFICATION" && currentActive !== undefined)
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <Notification selectedCompany={selectedCompany} />
        </MidleTaskbar>
      );
    if (currentTab === "FOLDER" && isLZOClicked)
      return (
        <MidleTaskbar currentTab={currentTab} isExtend={isExtend}>
          <FolderDocumentMiddle selectedCompany={selectedCompany} />
        </MidleTaskbar>
      );

    return null;
  };

  const setTaskbar = () => {
    const taskbar = document.querySelector(".task-bar");
    const slidebar = document.querySelector(".slide-bar");

    if (!taskbar || !slidebar) return;

    const slidebarHeight = slidebar.getBoundingClientRect().height;
    taskbar.style.height = `calc(100% - ${1000}px)`;
  };

  window.addEventListener("resize", setTaskbar);

  useEffect(() => {
    console.log("useEffect se okida");
    setTaskbar();
  }, []);

  return (
    <div className="task-bar">
      <div className="part">
        <SideBar
          renderContent={() => renderContent(currentTab)}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
          slideButton={slideButton}
          setSlideButton={setSlideButton}
          setSpeakerButton={setSpeakerButton}
          // setFolderButton={setFolderButton}
          setLanguageButton={setLanguageButton}
          // folderButton={folderButton}
          languageButton={languageButton}
          speakerButton={speakerButton}
          checkBack={checkBack}
          setCheckBack={setCheckBack}
          sideBarRef={sideBarRef}
        />

        {renderMiddleContent()}
      </div>
      {/* {selectedItem.locations && (
        <AddLocation
          selectedAccount={selectedAccount}
          setSelectedAccount={setSelectedAccount}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          setCompanies={setCompanies}
          selectedCompany={selectedCompany}
        />
      )}
      {selectedItem.users && (
        <AddLocation
          selectedAccount={selectedAccount}
          setSelectedAccount={setSelectedAccount}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />
      )} */}
      <ScrollText />

      <div
        onClick={() => {
          fileInputRef.current.value = "";
          if (isGlobalnoDodavanjeDokumenta) {
            setIsGlobalnoDodavanjeDokumenta(false);
            setFileNewDocument(false);
          } else {
            fileInputRef.current.click();
          }
        }}
        style={{
          height: "calc(100% / 7.7 )",
          zIndex: 1,
          position: "absolute",
          right: 0,
          width: "calc(100vw / 11 * 2 )",
        }}
      >
        <input
          id="globalno-dodavanje-input"
          type="file"
          accept="image/*, .pdf, .docx"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={(e) => {
            const file = e.target.files[0];
            if (!file) {
              setIsGlobalnoDodavanjeDokumenta(false);
              return;
            }
            setIsGlobalnoDodavanjeDokumenta(true);
            setFileNewDocument(e.target.files[0]);
          }}
        />
        <Button active={isGlobalnoDodavanjeDokumenta}>
          <img src={plusIcon} style={{ marginRight: "10px" }} />
          <span style={{ fontWeight: "bold" }}>
            {dictionary["dodajNoviDokument"]}
          </span>
        </Button>
      </div>

      <div className="options-container">
        <div className="options-btn" onClick={handleCancel}>
          <Button activation={true}>
            <img src={cancelIcon} alt="" className="options-img" />
          </Button>
        </div>
        <div className="options-section">
          <div className="options-btn" onClick={handleExtendMidle}>
            <Button>
              <img src={extendMidleIcon} alt="" className="options-img" />
            </Button>
          </div>
          <div className="options-slider" />
          <div
            className="options-btn"
            onClick={() => setShowSettings(!showSettings)}
          >
            <Button>
              <img src={settingsIcon} alt="" className="options-img" />
            </Button>
          </div>
        </div>
      </div>
      {showSettings && <Settings list={settings} />}
    </div>
  );
}

export default Taskbar;
